<template>
  <div class="wrap" v-if="loaded">
    <div class="route-area">
      <router-link class="route" to="/admin/company08">企業ページ</router-link>
      <router-link class="route" to="/admin/provider08">ママページ</router-link>
    </div>
    <modal class="modal" name="reject-modal" height=50% :scrollable="true">
        <div class="loading-container" v-show="isRejecting">
          <vue-loading type="spin" color="#333" :size="{ width: '100px', height: '100px' }"></vue-loading>
          <span>メール送信中・・・</span>
        </div>
      <div class="modal-title">却下理由</div>
        <div class="modal-form">
          <textarea rows="4" cols="40" v-model="reasonForRejection" type="text" name="present"/><br>
        <div class="btnarea"><button :disabled="isRejecting" @click="reject(rejectCompany)">却下する</button><button  :disabled="isRejecting" @click="$modal.hide('reject-modal')">キャンセル</button></div>
      </div>
    </modal>
    <!-- company -->
    <Companies
      v-if="fetchUserType === 'company08' && loaded"
      @open-reject-modal="openRejectModal"
      @open-edit-modal="edit"
      @accept="accept"
      @delete-user="confirmDeleteUser"
      :notApprovedCompanyData="displayNotApprovedUserData"
      :approvedCompanyData="displayApprovedUserData" />
    <!-- provider -->
    <Providers
       v-if="fetchUserType==='provider08' && loaded"
       @open-reject-modal="openRejectModal"
       @open-edit-modal="edit"
       @accept="accept"
       @delete-user="confirmDeleteUser"
      :notApprovedProviderData="displayNotApprovedUserData"
      :approvedProviderData="displayApprovedUserData" />
    <modal name="edit-company-modal" height=auto width=1000 :scrollable="true">
      <ValidationObserver
      v-slot="{ invalid, passes }"
      tag="div">
      <form @submit.prevent="passes(updateCompany08(editUser.docId))">
        <div class="container">
          <table>
            <tr>
              <th>会社名※</th>
              <td class="content">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <input class="answer" type="text" v-model="editUser.company_name"><br>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <th>担当者名※</th>
              <td class="content">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <input class="answer" type="text" v-model="editUser.name"><br>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <th>担当者アドレス※</th>
              <td class="content">
                <ValidationProvider rules="email" v-slot="{ errors }">
                  <input class="answer" type="text" v-model="editUser.email"><br>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <th>担当者電話番号（必須）※</th>
              <td class="content">
                <ValidationProvider rules="numeric" v-slot="{ errors }">
                  <input class="answer" type="text" v-model="editUser.tel"><br>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <th class="image-discription">イメージ画像（必須）</th>
              <td class="content">
                <ValidationProvider rules="size:100000" v-slot="{ errors }" ref="image">
                  <img class="inputimg" :src="editUser.image">
                  <div class="upload-img">
                    <input class="image" type="file" name="image" @change="uploadImage">
                  </div>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
          </table>
          <table>
            <div class="question">
              <tr>
                <th>配信タイトル（必須・20文字以内）</th>
                <td class="content">
                  <ValidationProvider rules="max:20" v-slot="{ errors }">
                    <input class="answer" type="text" v-model="editUser.eventname"><br>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th>配信開始時間（必須）</th>
                <td class="content">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <div class="day">27日（木）<br></div>
                    <div class="checkboxTime">
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="1" v-model="editUser.deliveryFrame">10:30
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="2" v-model="editUser.deliveryFrame">11:00
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="3" v-model="editUser.deliveryFrame">11:30<br>
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="4" v-model="editUser.deliveryFrame">12:00
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="5" v-model="editUser.deliveryFrame">12:30<br>
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="6" v-model="editUser.deliveryFrame">13:00
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="7" v-model="editUser.deliveryFrame">13:30
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="8" v-model="editUser.deliveryFrame">14:00<br>
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="9" v-model="editUser.deliveryFrame">14:30
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="10" v-model="editUser.deliveryFrame">15:00<br>
                    </div>
                    <div class="day">28日（金）<br></div>
                    <div class="checkboxTime">
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="11" v-model="editUser.deliveryFrame">10:30
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="12" v-model="editUser.deliveryFrame">11:00
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="13" v-model="editUser.deliveryFrame">11:30<br>
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="14" v-model="editUser.deliveryFrame">12:00
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="15" v-model="editUser.deliveryFrame">12:30<br>
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="16" v-model="editUser.deliveryFrame">13:00
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="17" v-model="editUser.deliveryFrame">13:30
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="18" v-model="editUser.deliveryFrame">14:00<br>
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="19" v-model="editUser.deliveryFrame">14:30
                      <input class="checkbox" type="checkbox" name="deliveryFrame" value="20" v-model="editUser.deliveryFrame">15:00<br>
                    </div>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th>配信スケジュール（必須）</th>
                <td class="contentradio">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input class="radio" type="radio" name="deliveryTime" value="1" v-model="editUser.deliveryTime">10分
                    <input class="radio" type="radio" name="deliveryTime" value="2" v-model="editUser.deliveryTime">15分
                    <input class="radio" type="radio" name="deliveryTime" value="3" v-model="editUser.deliveryTime">20分
                    <input class="radio" type="radio" name="deliveryTime" value="4" v-model="editUser.deliveryTime">25分
                    <input class="radio" type="radio" name="deliveryTime" value="5" v-model="editUser.deliveryTime">30分<br>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th>視聴者特典（500文字以内）</th>
                  <td class="content">
                    <ValidationProvider rules="max:500" v-slot="{ errors }">
                      <textarea class="txt" v-model="editUser.present" type="text" name="present"/><br>
                      <span class="error">{{ errors[0] }}</span>
                    </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th>配信内容（500文字以内）</th>
                <td class="content">
                  <ValidationProvider rules="max:1000" v-slot="{ errors }">
                    <textarea class="txt" v-model="editUser.detail" type="text" name="detail"/><br>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th>配信ツール選択（必須）</th>
                <td class="contentradio">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input class="radio" type="radio" name="tool" value="1" v-model="editUser.tool">Instagramライブ<br>
                    <input class="radio" type="radio" name="tool" value="2" v-model="editUser.tool" >Zoomウェビナー<br>
                    <input class="radio" type="radio" name="tool" value="3" v-model="editUser.tool">YouTubeライブ<br>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th>視聴者用URL（必須）</th>
                <td class="content">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input class="answer" type="text" v-model="editUser.url"><br>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th>出展社名（必須）</th>
                <td class="content">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input class="answer" type="text" v-model="editUser.exhibitorName"><br>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th>出展社URL（必須）</th>
                <td class="content">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input class="exhibitorAnswer" type="text" v-model="editUser.exhibitorUrl">
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
            </div>
          </table>
          <div class="btn-wrapper btn-next"><br>
            <button
            type="submit"
            class="btn"
            >送信</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
    </modal>
    <modal name="edit-provider-modal" height=auto width=1000 :scrollable="true">
      <ValidationObserver
      v-slot="{ invalid, passes }"
      tag="div">
      <form @submit.prevent="passes(updateProvider(editUser.docId))">
        <div class="container">
          <table>
            <tr>
              <th>申込者名（必須）</th>
              <td class="content">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <input class="answer" type="text" v-model="editUser.name"><br>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <th>申込者アドレス（必須）</th>
              <td class="content">
                <ValidationProvider rules="email" v-slot="{ errors }">
                  <input class="answer" type="text" v-model="editUser.email"><br>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <th>担当者アドレス※</th>
              <td class="content">
                <ValidationProvider rules="email" v-slot="{ errors }">
                  <input class="answer" type="text" v-model="editUser.email"><br>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <th>申込者電話番号（必須）</th>
              <td class="content">
                <ValidationProvider rules="numeric" v-slot="{ errors }">
                  <input class="answer" type="text" v-model="editUser.tel"><br>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <th>見逃し配信用URL</th>
                <td class="content">
                  <input class="answer" type="text" v-model="editUser.ｍissedUrl"><br>
                </td>
              </tr>
          </table>
          <table>
            <div class="question">
              <tr>
                <th>配信タイトル</th>
                <td class="content">
                  <input class="answer" type="text" v-model="editUser.title">
                </td>
              </tr>
              <tr>
                <th class="image-discription">イメージ画像（必須）</th>
                <td class="content">
                  <ValidationProvider rules="size:700" v-slot="{ errors }" ref="image">
                    <img class="inputimg" :src="editUser.image">
                    <div class="upload-img">
                      <input class="image" type="file" name="image" @change="uploadImage">
                    </div>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th>配信スケジュール※</th>
                <td class="content">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <div class="day">27日（木）<br></div>
                      <div class="checkboxTime">
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="1" v-model="editUser.deliveryFrame">10:30
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="2" v-model="editUser.deliveryFrame">11:00
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="3" v-model="editUser.deliveryFrame">11:30<br>
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="4" v-model="editUser.deliveryFrame">12:00
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="5" v-model="editUser.deliveryFrame">12:30<br>
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="6" v-model="editUser.deliveryFrame">13:00
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="7" v-model="editUser.deliveryFrame">13:30
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="8" v-model="editUser.deliveryFrame">14:00<br>
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="9" v-model="editUser.deliveryFrame">14:30
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="10" v-model="editUser.deliveryFrame">15:00<br><br>
                      </div>
                    <div class="day">28日（金）<br></div>
                      <div class="checkboxTime">
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="11" v-model="editUser.deliveryFrame">10:30
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="12" v-model="editUser.deliveryFrame">11:00
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="13" v-model="editUser.deliveryFrame">11:30<br>
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="14" v-model="editUser.deliveryFrame">12:00
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="15" v-model="editUser.deliveryFrame">12:30<br>
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="16" v-model="editUser.deliveryFrame">13:00
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="17" v-model="editUser.deliveryFrame">13:30
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="18" v-model="editUser.deliveryFrame">14:00<br>
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="19" v-model="editUser.deliveryFrame">14:30
                        <input class="checkbox" type="checkbox" name="deliveryFrame" value="20" v-model="editUser.deliveryFrame">15:00<br>
                      </div>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th>配信時間（1つのみ※各配信共通）※</th>
                <td class="contentradio">
                    <input class="radio" type="radio" name="deliveryTime" value="2" v-model="editUser.deliveryTime">15分
                    <input class="radio" type="radio" name="deliveryTime" value="5" v-model="editUser.deliveryTime" >30分
                    <input class="radio" type="radio" name="deliveryTime" value="6" v-model="editUser.deliveryTime">40分
                    <input class="radio" type="radio" name="deliveryTime" value="7" v-model="editUser.deliveryTime">60分<br>
                </td>
              </tr>
              <tr>
                <th>対象年齢</th>
                <td class="contentAge">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <span class="error">{{ errors[0] }}</span>
                    <section v-for="(age, key) in getTargetAgeObject" :key="key">
                      <input v-model="editUser.age" :value="key" class="checkbox" type="checkbox"  name="deliveryTime">{{ age }}
                    </section>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th >配信内容</th>
                <td class="content">
                  <textarea class="txt" v-model="editUser.detail" type="text" name="detail"/>
                </td>
              </tr>
              <tr>
                <th>配信ツール選択（1つのみ/各配信共通）※</th>
                <td class="contentradio">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input class="radio" type="radio" name="tool" value="1" v-model="editUser.tool">Instagramライブ<br>
                    <input class="radio" type="radio" name="tool" value="2" v-model="editUser.tool" >YouTubeライブ<br>
                    <input class="radio" type="radio" name="tool" value="3" v-model="editUser.tool">Zoom（ミーティング）無料アカウント<br>
                    <input class="radio" type="radio" name="tool" value="4" v-model="editUser.tool">Zoom（ミーティング）有料アカウント<br>
                    <input class="radio" type="radio" name="tool" value="5" v-model="editUser.tool">Zoomウェビナー（有料）<br>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th>視聴者用URL※</th>
                <td class="content">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input class="answer" type="text" v-model="editUser.url"><br>
                    <span class="comment">※2日間出展される場合でも同じURLで配信できます。</span>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <div class="box">
                <tr>
                  <th>出展者名（必須）</th>
                  <td class="content">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <input class="answer" type="text" v-model="editUser.eventName"><br>
                      <span class="error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </td>
                </tr>
                <tr>
                  <th>出展者URL（企業HPなど）※</th>
                  <td class="content">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <input class="exhibitorAnswer" type="text" v-model="editUser.exhibitor_url1"><br>
                      <input class="exhibitorAnswer" type="text" v-model="editUser.exhibitor_url2"><br>
                      <input class="exhibitorAnswer" type="text" v-model="editUser.exhibitor_url3">
                      <span class="error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </td>
                </tr>
              </div>
            </div>
          </table>
          <div class="btn-wrapper btn-next"><br>
            <button
            type="submit"
            class="btn"
            :disabled="invalid">送信</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase'
import 'firebase/firestore'
import 'firebase/functions'
import { VueLoading } from 'vue-loading-template'
import Companies from '@/components/organisms/Companies.vue'
import Providers from '@/components/organisms/Providers.vue'

export default {
  data () {
    return {
      userData: [],
      tools: { 1: 'Instagramライブ', 2: 'Zoomウェビナー', 3: 'YouTubeライブ' },
      provider_tools: { 1: 'Instagramライブ', 2: 'YouTubeライブ', 3: 'Zoom（ミーティング）無料アカウント', 4: 'Zoom（ミーティング）有料アカウント', 5: 'Zoomウェビナー（有料）' },
      masterDeliveryFrameObj: { 1: '10:30', 2: '11:00', 3: '11:30', 4: '12:00', 5: '12:30', 6: '13:00', 7: '13:30', 8: '14:00', 9: '14:30', 10: '15:00', 11: '10:30', 12: '11:00', 13: '11:30', 14: '12:00', 15: '12:30', 16: '13:00', 17: '13:30', 18: '14:00', 19: '14:30', 20: '15:00' },
      loaded: false,
      editDocId: '',
      reasonForRejection: '',
      rejectCompany: {},
      editUser: {},
      db: null,
      approvedCompanyData: [],
      isRejecting: false
    }
  },
  components: {
    VueLoading,
    Companies,
    Providers
    // DisApprovedProvider
  },
  methods: {
    async getUserData (userType) {
      this.db.collection(userType).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((user, idx) => {
            const userData = user.data()
            userData.docId = user.id
            userData.fetchDeliveryFrame = this.getDeliveryFrame(userData.deliveryFrame)
            userData.fetchDeliveryTime = this.getDeliveryTime(userData.deliveryTime)
            userData.fetchTool = this.getToolName(userData.tool)
            if (userType === 'provider08') {
              userData.fetchTargetAge = this.ArrayToStr(userData.age.map(age => {
                return this.getTargetAgeObject[age]
              }))
            }
            this.userData.push(userData)
          })
        })
    },
    getToolName (tool) {
      if (this.fetchUserType === 'company08') {
        return this.tools[tool]
      }
      return this.provider_tools[tool]
    },
    getProviderToolName (tool) {
      return this.provider_tools[tool]
    },
    getDeliveryFrame (deliveryFrame) {
      if (!deliveryFrame) {
        return null
      }
      deliveryFrame.slice().sort((a, b) => {
        return a - b
      })
      // 1~10が28日（火）、11~20が29日（水）
      const masterDeliveryFrameObj = this.masterDeliveryFrameObj
      let deliveryFrameMsg = ''
      let hasThuTitle = false
      let hasWedTitle = false
      for (let i = 0; i < deliveryFrame.length; i++) {
        const time = masterDeliveryFrameObj[deliveryFrame[i]] // 時刻
        if (i === 0 && deliveryFrame[0] < 11) { // 木曜日
          deliveryFrameMsg = deliveryFrameMsg + '27日（木）\n' + time + '\n'
          hasWedTitle = true
          continue
        }
        if (deliveryFrame[i] < 11) {
          deliveryFrameMsg = deliveryFrameMsg + time + '\n'
        }
        if (deliveryFrame[i] >= 11 && !hasThuTitle) { // 金曜日
          if (hasWedTitle) {
            deliveryFrameMsg = deliveryFrameMsg + '\n'
          }
          deliveryFrameMsg = deliveryFrameMsg + '\n' + '28日（金）' + '\n' + time + '\n'
          hasThuTitle = true
          continue
        }
        if (deliveryFrame[i] >= 11) {
          deliveryFrameMsg = deliveryFrameMsg + time + '\n'
        }
      }
      return deliveryFrameMsg
    },
    edit (user) {
      this.editUser = { ...user }
      if (this.fetchUserType === 'company08') {
        this.$modal.show('edit-company-modal')
      } else if (this.fetchUserType === 'provider08') {
        this.$modal.show('edit-provider-modal')
      }
    },
    reject (company08) {
      this.isRejecting = true
      const functions = firebase.app().functions('asia-northeast1')
      const sendRejectMail = functions.httpsCallable('sendRejectMail')
      sendRejectMail({
        email: company08.email,
        name: company08.name,
        reasonForRejection: this.reasonForRejection,
        type: this.fetchUserType
      })
        .then((response) => {
          // 却下処理
          this.db.collection(this.fetchUserType).doc(company08.docId).update({
            isApproved: false,
            isRejected: true
          }).then((res) => {
            this.isRejecting = false
            alert('却下しました')
            location.reload()
          }).catch((err) => {
            alert('却下に失敗しました')
            console.log(err)
          })
        })
        .catch(e => {
          alert('メールの送信に失敗しました')
          console.log(e)
          this.isRejecting = false
        })
    },
    openRejectModal (company08) {
      this.rejectCompany = company08
      this.$modal.show('reject-modal')
    },
    accept (docId) {
      const answer = confirm('承認しますか？')
      if (answer) {
        this.acceptUser(docId)
      }
    },
    confirmDeleteUser (docId) {
      const answer = confirm('削除してもよろしいですか？')
      if (answer) {
        this.deleteUser(docId)
      }
    },
    acceptUser (docId) {
      this.db.collection(this.fetchUserType).doc(docId).update({
        isApproved: true
      }).then((res) => {
        alert('承認しました')
        location.reload()
      }).catch((err) => {
        console.log(err)
      })
    },
    deleteUser (docId) {
      this.db.collection(this.fetchUserType).doc(docId).update({
        isApproved: false,
        isRejected: true
      }).then((res) => {
        this.isRejecting = false
        alert('削除しました')
        location.reload()
      }).catch((err) => {
        alert('削除しました')
        console.log(err)
      })
    },
    async fetchData () {
      this.userData = []
      this.db = firebase.firestore()
      await this.getUserData(this.fetchUserType).then(() => {
        this.loaded = true
      })
    },
    getDeliveryTime (deliveryTime) {
      const master = { 1: '１０分', 2: '１５分', 3: '２０分', 4: '２５分', 5: '３０分', 6: '４０分', 7: '６０分' }

      return master[deliveryTime]
    },
    updateProvider () {
      console.log(this.editUser)
      const dbProvider08 = this.db.collection(this.fetchUserType)
      dbProvider08.doc(this.editUser.docId)
        .update({
          name: this.editUser.name,
          email: this.editUser.email,
          tel: this.editUser.tel,
          ｍissedUrl: this.editUser.ｍissedUrl,
          group_name: this.editUser.group_name,
          title: this.editUser.title,
          image: this.editUser.image,
          deliveryFrame: this.editUser.deliveryFrame,
          deliveryTime: this.editUser.deliveryTime,
          detail: this.editUser.detail,
          tool: this.editUser.tool,
          url: this.editUser.url,
          eventName: this.editUser.eventName,
          exhibitor_url1: this.editUser.exhibitor_url1,
          exhibitor_url2: this.editUser.exhibitor_url2,
          exhibitor_url3: this.editUser.exhibitor_url3,
          isApproved: this.editUser.isApproved || false,
          isRejected: this.editUser.isRejected || false,
          age: this.editUser.age
        })
        .then(res => {
          this.storeImage(this.editUser.name).then((snapShot) => {
            snapShot.ref.getDownloadURL().then(downloadURL => {
              dbProvider08.doc(this.editUser.docId).update({ imageUrl: downloadURL })
              this.posted = true
              alert('更新しました')
              location.reload()
            })
          })
        })
        .catch(e => {
          alert('更新に失敗しました')
          console.log(e)
        })
    },
    async storeImage (name) {
      const ref = `pictures/${name}/${this.fileName}`
      const storageRef = firebase.storage().ref().child(ref)
      return await storageRef.putString(this.editUser.image, 'data_url')
    },
    updateCompany08 (docId) {
      this.db.collection('company08').doc(docId)
        .update({
          company_name: this.editUser.company_name,
          name: this.editUser.name,
          email: this.editUser.email,
          tel: this.editUser.tel,
          eventname: this.editUser.eventname,
          deliveryFrame: this.editUser.deliveryFrame,
          deliveryTime: this.editUser.deliveryTime,
          present: this.editUser.present,
          detail: this.editUser.detail,
          tool: this.editUser.tool,
          url: this.editUser.url,
          exhibitorName: this.editUser.exhibitorName,
          exhibitorUrl: this.editUser.exhibitorUrl,
          isApproved: this.editUser.isApproved || false,
          isRejected: this.editUser.isRejected || false
        })
        .then(ref => {
          alert('更新しました')
          location.reload()
        })
        .catch(e => {
          alert('更新に失敗しました')
        })
    },
    async uploadImage (event) {
      const { valid } = await this.$refs.image.validate(event)
      if (valid) {
        const files = event.target.files || event.dataTransfer.files
        const file = files[0]
        this.fileName = file.name
        const img = await this.getBase64(file)
        this.editUser.image = img
      } else {
        console.log(valid)
      }
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    ArrayToStr (data) {
      if (!data) {
        return ''
      }
      let str = ''
      for (let i = 0; i < data.length; i++) {
        if (i !== data.length - 1) {
          str = str + data[i] + ','
        } else {
          str = str + data[i]
        }
      }
      return str
    }
  },
  watch: {
    // ルートが変更されたら呼び出すメソッド
    $route: 'fetchData'
  },
  computed: {
    displayNotApprovedUserData () {
      return this.userData.filter((user) => {
        return !user.isApproved && !user.isRejected
      })
    },
    displayApprovedUserData () {
      return this.userData.filter((user) => {
        return user.isApproved && !user.isRejected
      })
    },
    fetchUserType () {
      return this.$route.params.type
    },
    ...mapGetters([
      'getTargetAgeObject'
    ])
  },
  async mounted () {
    this.fetchData()
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  padding: 0;
  width: 850px;
  table-layout: fixed;
}

table tr {
  background-color: #fff;
  padding: .35em;
  border: 2px solid #eee;
}

table th{
  padding: 0.5em;
  border-right: 2px solid #fff;
  width: 100px;
}
table td {
  padding: .5em .5em;
  border-right: 2px solid #eee;
  text-align: center;
}
table th {
  font-size: .85em;
}
table thead tr{
  background-color: #50535d;
  color:#fff;
}
table tbody th {
    border-right: 2px solid #eee;
}
th.non {
    border-right: none;
}
.txt{
  text-align: left;
  font-size: .85em;
}
.modal-title {
  text-align: center;
  font-size: 1.3em;
  margin-top: 30px;
}
.modal-form {
  text-align: center;
  margin-top: 20px
}
.modal-form button {
  margin: 20px;
}
.route-area {
  margin: 20px 20px 20px 0;
  font-size: 1.5em;
}
.route-area .route{
  margin-left: 50px;
}
.loading-container {
  position: absolute;
  top: 30%;
  left: 40%;
}
.inputimg {
  max-width: 50%;
  margin: 10px;
}
.image-discription {
  vertical-align: middle;
}
section {
  display: inline;
}
</style>
